import type { ThemeConfig } from "antd";

/** Calm, low-saturation palette: deep blue primary, soft grey ground. */
export const theme: ThemeConfig = {
  token: {
    colorPrimary: "#274c77",
    colorBgLayout: "#f3f5f8",
    borderRadius: 6,
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif'
  },
  components: {
    Layout: { headerBg: "#ffffff", headerHeight: 56, siderBg: "#ffffff" },
    Menu: { itemBorderRadius: 6, itemSelectedBg: "#e6edf5", itemSelectedColor: "#274c77" }
  }
};
